import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  CtBinaryOperator,
  CtButtonConfiguration,
  CtCardConfiguration,
  CtCardIconConfiguration,
  CtCardIconPosition,
  CtCardTemplate,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelService,
} from '@ctsolution/ct-framework';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';
import { TaskRouteData } from '../../../_core/route-data/task.route-data';
import { CtAuthenticationService } from '@ctsolution/ct-authentication';

@Injectable()
export class DashboardTaskHelper {
  constructor(
    private router: Router,
    private managerService: CtManagerService,
    private modelService: CtModelService<any>,
    private authService: CtAuthenticationService
  ) {}

  getTaskWidgets(cardList: CtCardConfiguration[]) {
    this.getMyTasksCard(cardList);
    this.getAllTasksCard(cardList);
  }

  private async getMyTasksCard(cardList: CtCardConfiguration[]) {
    this.managerService
      .getComponentOverride(
        'dashboard',
        'my_tasks',
        MY_TASKS_CARD
      )
      .then((component) => {
        return;
      });

    const userId = this.authService.userValue?.UserClaimsRegistry?.Oid;

    if (!userId) {
      console.warn('User ID not found');
      return;
    }

    const userIdNumber = typeof userId === 'string' ? parseInt(userId, 10) : userId;

    const filters = [
      CTModelDatatableFilter.create()
        .setField('SystemUser.Oid')
        .setValue(userIdNumber)
        .setOperatorType(CtBinaryOperator.Equal),
    ];

    const result = await this.getTasksByFilter(filters);

    const count = result?.TotalElement ?? 0;
    MY_TASKS_CARD.setDescription(`${count > 0 ? count : '0'}`);

    const queryObject = {
      constants: [
        {
          Field: 'SystemUser.Oid',
          OperatorType: CtBinaryOperator.Equal,
          Value: userIdNumber,
        },
      ],
    };

    const queryString = JSON.stringify(queryObject);
    const urlTree: UrlTree = this.router.createUrlTree(['/task/list'], {
      queryParams: { q: queryString },
    });
    const fullUrl = this.router.serializeUrl(urlTree);

    MY_TASKS_CARD.setAction(() => window.open(fullUrl, '_blank'));

    cardList.push(MY_TASKS_CARD);
  }

  private async getAllTasksCard(cardList: CtCardConfiguration[]) {
    this.managerService
      .getComponentOverride(
        'dashboard',
        'all_tasks',
        ALL_TASKS_CARD
      )
      .then((component) => {
        return;
      });

    // Nessun filtro = tutti i task
    const filters: Array<CTModelDatatableFilter> = [];

    const result = await this.getTasksByFilter(filters);

    const count = result?.TotalElement ?? 0;
    ALL_TASKS_CARD.setDescription(`${count > 0 ? count : '0'}`);

    // Naviga alla lista di tutti i task
    ALL_TASKS_CARD.setAction(() =>
      this.router.navigate(['/task/list'])
    );

    cardList.push(ALL_TASKS_CARD);
  }

  private getTasksByFilter(filters: Array<CTModelDatatableFilter>) {
    const configuration: CtModelConfiguration<any> =
      CtModelConfiguration.create().setRouteData(TaskRouteData());

    const operators: CtModelDatatableOperators =
      CtModelDatatableOperators.create().setFilters(filters);

    return new Promise<CtModelConfiguration<Array<any>>>((resolve) => {
      this.modelService
        .getList(configuration, operators)
        .subscribe((response) => resolve(response.Result));
    });
  }
}

export const MY_TASKS_CARD: CtCardConfiguration =
  CtCardConfiguration.create()
    .setTitle('dashboard.myTasks')
    .setVisible(false)
    .setTemplate(CtCardTemplate.COUNTER)
    .setClass('bg-warning text-white');

export const ALL_TASKS_CARD: CtCardConfiguration =
  CtCardConfiguration.create()
    .setTitle('dashboard.allTasks')
    .setVisible(false)
    .setTemplate(CtCardTemplate.COUNTER)
    .setClass('bg-warning text-white');
